import React, { Component } from 'react';
import { connect } from 'react-redux';
import qs from 'qs';

import { fetchNotes, createNote, updateNote } from '../actions/notes';
import { getNotes, getPageCount } from '../reducers';

const notePage = (DecoratedComponent) => {
  class NotePage extends Component {
    componentDidMount() {
      this.fetchNotes();
    }

    componentDidUpdate(oldProps) {
      if (
        this.props.subId !== oldProps.subId ||
        this.props.userId !== oldProps.userId
      ) {
        this.fetchNotes();
      }
    }

    fetchNotes = () => {
      const { fetchNotes, sub, userId, page } = this.props;

      if (sub || userId) {
        return fetchNotes(
          {
            user_profile: userId,
            subscription: sub && sub.sprint_status && sub.id,
            att_subscription: sub && sub.att_status && sub.id,
            tracfone_subscription: sub && sub.tracfone_status && sub.id,
            simo_subscription: sub && sub.simo_status && sub.id,
            quick_subscription: sub && sub.quick_status && sub.id,
          },
          page,
        );
      }
    };

    render() {
      const { children, ...props } = this.props;
      return React.createElement(
        DecoratedComponent,
        {
          ...props,
          fetchNotes: this.fetchNotes,
        },
        children,
      );
    }
  }

  const mapStateToProps = (state, { location: { search } }) => {
    const { page = 1 } = qs.parse(search, { ignoreQueryPrefix: true });
    return {
      notes: getNotes(state, page),
      notesFirstPageAlways: getNotes(state, 1),
      pageCount: getPageCount(state, 'notes', `fetchNotes`, page),
      page,
    };
  };

  const mapDispatchToProps = {
    fetchNotes,
    createNote,
    updateNote,
  };

  NotePage = connect(mapStateToProps, mapDispatchToProps)(NotePage);

  return NotePage;
};

export default notePage;
